import { InjectionToken } from '@angular/core';
import { ServiceInfo } from '@shared/core';

export interface ContractConditionsText {
	paymentCreditCard: string;
	paymentDas: string;
	paymentInternet: string;
	paymentPpa: string;
	service: string;
}

/** Fallback legal copy when an organization has no custom conditions. Each AppModule provides its own texts. */
export const CONTRACT_CONDITIONS_TEXT = new InjectionToken<ContractConditionsText>('CONTRACT_CONDITIONS_TEXT');

export interface SubscriptionServiceModel {
	partialPrice: any;
	startDate: { toISOString(): string };
	partialEndDate: { toISOString(): string };
	partialInvoiceToDate: { toISOString(): string };
}

export type ServiceModelCtor = new (service: ServiceInfo) => SubscriptionServiceModel;

/**
 * Each app provides its own `Service` class from `utils/service-model.ts`.
 * Pricing / date math still differs between cem and public.
 */
export const SERVICE_MODEL = new InjectionToken<ServiceModelCtor>('SERVICE_MODEL');
